/* eslint-disable prettier/prettier */
//numbercount
// rolling-number.ts
export function initRollingNumber(): void {
    const els = document.querySelectorAll<HTMLElement>('.rolling-number');

    // Fallback för äldre browsers
    if (!('IntersectionObserver' in window)) {
        els.forEach(startRollingNumber);
        return;
    }

    //const observer = new IntersectionObserver((entries, obs) => {
    //    entries.forEach(entry => {
    //        if (!entry.isIntersecting) return;

    //        const el = entry.target as HTMLElement;

    //        // Unobserve bara när vi faktiskt renderat något vettigt
    //        const rendered = startRollingNumber(el);
    //        if (rendered) {
    //            obs.unobserve(el);
    //        }
    //    });
    //}, {
    //    root: null,
    //    threshold: 0.2
    //});

    //els.forEach(el => observer.observe(el));
    const observer = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    startRollingNumber(entry.target as HTMLElement);
                    obs.unobserve(entry.target); // Kör bara en gång
                }
            });
        },
        {
            root: null,      // viewport
            threshold: 0.2   // ~20 % av elementet synligt räcker
        }
    );

    els.forEach(el => observer.observe(el));
}
//function startRollingNumber(el: HTMLElement): boolean {
//    const value = (el.dataset.number ?? '').trim();

//    // Om värdet inte finns än (eller är placeholder), rendera inte och lås inte
//    if (!value || value === '0') return false;

//    // Rendera bara om värdet ändrats (bättre än dataset.rolled)
//    if (el.dataset.renderedValue === value) return true;
//    el.dataset.renderedValue = value;

//    el.innerHTML = '';

//    const digitsContainer = document.createElement('div');
//    digitsContainer.className = 'digits';
//    el.appendChild(digitsContainer);

//    for (let i = 0; i < value.length; i++) {
//        const char = value[i];

//        if (char >= '0' && char <= '9') {
//            const char = value[i];

//            if (/\d/.test(char)) {
//                const digitWrapper = document.createElement('div');
//                digitWrapper.className = 'digit';

//                const digitInner = document.createElement('div');
//                digitInner.className = 'digit-inner';

//                const digitValue = parseInt(char, 10);
//                const repeatCount = 3;

//                for (let r = 0; r < repeatCount; r++) {
//                    for (let j = 0; j <= 9; j++) {
//                        const span = document.createElement('span');
//                        span.textContent = j.toString();
//                        digitInner.appendChild(span);
//                    }
//                }

//                digitWrapper.appendChild(digitInner);
//                digitsContainer.appendChild(digitWrapper);

//                const totalHeight = 1.15;        // em
//                const targetRow = 10 + digitValue;
//                const rawDelay = i * 100;
//                const delay = rawDelay === 0 ? 50 : rawDelay;

//                // Liten layout-delay innan vi börjar animera
//                setTimeout(() => {
//                    // tvinga webbläsaren att reflow:
//                    digitInner.getBoundingClientRect();

//                    // starta transition + transform
//                    digitInner.style.transition = 'transform 1800ms cubic-bezier(0.6, 0.05, 0.28, 0.91)';
//                    digitInner.style.transform = `translateY(-${(10 + digitValue) * totalHeight}em)`;

//                    // återställ vid slut
//                    setTimeout(() => {
//                        digitInner.style.transition = 'none';
//                        digitInner.style.transform = `translateY(-${digitValue * totalHeight}em)`;
//                    }, 1850);
//                }, delay);
//            }
//        }
//        else if (char === '-') {
//            const dash = document.createElement('span');
//            dash.className = 'dash dash--minus';
//            dash.textContent = '-';
//            digitsContainer.appendChild(dash);
//        } else if (char === ',' || char === '.') {
//            const sep = document.createElement('span');
//            sep.className = 'dash dash--decimal';
//            sep.textContent = ',';
//            digitsContainer.appendChild(sep);
//        } else {
//            // fallback så du inte tappar tecken tyst
//            const other = document.createElement('span');
//            other.className = 'dash';
//            other.textContent = char;
//            digitsContainer.appendChild(other);
//        }
//    }
//        // Suffix
//        const suffix = el.dataset.suffix;
//        if (suffix) {
//            const suffixEl = document.createElement('span');
//            suffixEl.className = 'suffix';
//            suffixEl.textContent = suffix;
//            digitsContainer.appendChild(suffixEl);
//        }

//        // Subheading
//        const subheading = el.dataset.subheading;
//        if (subheading) {
//            const subEl = document.createElement('p');
//            subEl.className = 'subheading';
//            subEl.textContent = subheading;
//            el.appendChild(subEl);
//        }

//    return true;
//}

function startRollingNumber(el: HTMLElement): void {
    // Skydd så vi inte råkar trigga igen
    if (el.dataset.rolled === 'true') return;
    el.dataset.rolled = 'true';

    const value = el.dataset.number ?? '0';
    el.innerHTML = '';

    const digitsContainer = document.createElement('div');
    digitsContainer.className = 'digits';
    el.appendChild(digitsContainer);

    for (let i = 0; i < value.length; i++) {
        const char = value[i];
       /* char.replace(/−/, "-"); */
        if (/\d/.test(char)) {
            const digitWrapper = document.createElement('div');
            digitWrapper.className = 'digit';

            const digitInner = document.createElement('div');
            digitInner.className = 'digit-inner';

            const digitValue = parseInt(char, 10);
            const repeatCount = 3;

            for (let r = 0; r < repeatCount; r++) {
                for (let j = 0; j <= 9; j++) {
                    const span = document.createElement('span');
                    span.textContent = j.toString();
                    digitInner.appendChild(span);
                }
            }

            digitWrapper.appendChild(digitInner);
            digitsContainer.appendChild(digitWrapper);

            const totalHeight = 1.15;        // em
            const targetRow = 10 + digitValue;
            const rawDelay = i * 100;
            const delay = rawDelay === 0 ? 50 : rawDelay;

            // Liten layout-delay innan vi börjar animera
            setTimeout(() => {
                // tvinga webbläsaren att reflow:
                digitInner.getBoundingClientRect();

                // starta transition + transform
                digitInner.style.transition = 'transform 1800ms cubic-bezier(0.6, 0.05, 0.28, 0.91)';
                digitInner.style.transform = `translateY(-${(10 + digitValue) * totalHeight}em)`;

                // återställ vid slut
                setTimeout(() => {
                    digitInner.style.transition = 'none';
                    digitInner.style.transform = `translateY(-${digitValue * totalHeight}em)`;
                }, 1850);
            }, delay);
        }
        else if (char === '-' || char === '–') {
            const dash = document.createElement('span');
            dash.className = 'dash dash--negative';
            dash.textContent = '-';
            digitsContainer.appendChild(dash);

            const hasNegative = document.getElementsByClassName('.rolling-number');
            hasNegative.item(0)?.classList.add('has-negative');

            
            console.log('value:', value, [...value].map(c => `${c} U+${c.charCodeAt(0).toString(16).toUpperCase()}`));
        }
        else if (char === ',' || char === '.') {
            const dash = document.createElement('span');
            dash.className = 'dash dash--decimal';
            dash.textContent = ',';
            digitsContainer.appendChild(dash);

            const hasDash = document.getElementsByClassName('.rolling-number');
            hasDash.item(0)?.classList.add('has-comma');
        }
    }

    // Suffix
    const suffix = el.dataset.suffix;
    if (suffix) {
        const suffixEl = document.createElement('span');
        suffixEl.className = 'suffix';
        suffixEl.textContent = suffix;
        digitsContainer.appendChild(suffixEl);
    }

    // Subheading
    const subheading = el.dataset.subheading;
    if (subheading) {
        const subEl = document.createElement('p');
        subEl.className = 'subheading';
        subEl.textContent = subheading;
        el.appendChild(subEl);
    }
}